import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Link, browserHistory, Route, withRouter, Switch, BrowserRouter as Router } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Card, { CardContent, CardMedia } from 'material-ui/Card';
import List from 'material-ui/List';
import Divider from 'material-ui/Divider';
import styles from './styles.js';
import { push } from 'react-router-redux';

// Icons
import InboxIcon from 'material-ui-icons/MoveToInbox';
import DraftsIcon from 'material-ui-icons/Share';
import StarIcon from 'material-ui-icons/Star';
import BuildIcon from 'material-ui-icons/Code';
import MailIcon from 'material-ui-icons/Mail';
import DeleteIcon from 'material-ui-icons/Delete';
import ReportIcon from 'material-ui-icons/Report';
import PersonIcon from 'material-ui-icons/Person';
import ProfilesIcon from 'material-ui-icons/SupervisorAccount';
import PhoneIcon from 'material-ui-icons/PhoneInTalk';
import HomeIcon from 'material-ui-icons/Home';
import LogoutIcon from 'material-ui-icons/Reply';
import SettingsIcon from 'material-ui-icons/Settings';
import SearchIcon from 'material-ui-icons/Search';
import ServiceLevelIcon from 'material-ui-icons/TrendingUp';
import BugReport from 'material-ui-icons/BugReport';

class Communication extends Component {
  render(){

    const { classes, theme } = this.props;

    const TO_PREFIX = "/console";

    return(
      <Router>
        <List>
      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX+"/display");}} disableRipple button className={classes.buttonHeight}>
        <ListItemIcon >
          <HomeIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Display Options
        </Typography>
      </ListItem>
      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/search");}} disableRipple button className={classes.buttonHeight}>
        <ListItemIcon >
          <SearchIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Search
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/my_profiles");}} disableRipple button className={classes.buttonHeight} link={TO_PREFIX + "/notifications"}>
        <ListItemIcon>
          <ProfilesIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          My Profiles
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/communication");}}  disableRipple button className={classes.buttonHeight}>
        <ListItemIcon>
          <DraftsIcon className={classes.iconFontSizeHighlighted}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSizeHighlighted}>
          Communication
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/special_services");}} disableRipple button className={classes.buttonHeight} link={TO_PREFIX + "/notifications"}>
        <ListItemIcon>
          <StarIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Special Services
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/service_level");}} disableRipple button className={classes.buttonHeight} link={TO_PREFIX + "/notifications"}>
        <ListItemIcon>
          <ServiceLevelIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Upgrade Service Level
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/profile");}} disableRipple button className={classes.buttonHeight} link={TO_PREFIX + "/notifications"}>
        <ListItemIcon>
          <PersonIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          My Account
        </Typography>
      </ListItem>

      <div className={classes.height10}>
        <Divider/>
      </div>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/submit_bug");}} disableRipple button className={classes.buttonHeight}>
        <ListItemIcon>
          <BugReport className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Submit a Bug
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/support");}} disableRipple button className={classes.buttonHeight}>
        <ListItemIcon>
          <MailIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Support
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/contact");}} disableRipple button className={classes.buttonHeight}>
        <ListItemIcon>
          <PhoneIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Contact
        </Typography>
      </ListItem>

      <ListItem onClick={() => {this.props.changeRoute(TO_PREFIX + "/logout");}} disableRipple button className={classes.buttonHeight}>
        <ListItemIcon>
          <LogoutIcon className={classes.iconFontSize}/>
        </ListItemIcon>
        <Typography type="body2" color="secondary" noWrap className={classes.textFontSize}>
          Log Out
        </Typography>
      </ListItem>
    </List>
    </Router>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(Communication));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/SideItems/components/Communication/index.js